import type { ReactNode } from 'react';
import { useAdmin } from '../adminContext';
import { RequirePermission } from '../RequirePermission';

export function OrderGuard({ permission, children }: { permission: string; children: ReactNode }) {
  const { session } = useAdmin();
  return (
    <RequirePermission session={session} permission={permission}>
      {children}
    </RequirePermission>
  );
}
